export { default } from './ArchiveLayout';
